import { defineRecipe } from "@chakra-ui/react";

const badgeRecipe = defineRecipe({
    base: {
        border: "1px solid",
        borderRadius: 4,
        px: 2,
        textTransform: "none",
        fontWeight: "normal",
        fontFamily: "secondary",
        lineHeight: "18px"
    },
    variants: {
        variant: {
            legacySuccess: {
                bg: "legacy.success.100",
                borderColor: "legacy.success.500",
                color: "legacy.success.500"
            },
            success: {
                bg: "success.300",
                borderColor: "success.500",
                color: "success.500"
            },
            legacyError: {
                bg: "legacy.danger.100",
                borderColor: "legacy.danger.500",
                color: "legacy.danger.500"
            },
            error: {
                bg: "danger.300",
                borderColor: "danger.500",
                color: "danger.500"
            },
            legacyWarning: {
                bg: "legacy.gray.100",
                borderColor: "legacy.warning.500",
                color: "legacy.warning.500"
            },
            assignmentStatus: {
                border: "none"
            }
        }
    },
    defaultVariants: {
        variant: "legacySuccess"
    }
});

export default badgeRecipe;
